/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './ColorTile.module.css';
export default function ColorTile({
    color,
    code,
    name,
    isSelected = false,
    onClick,
    className = ''
}) {
    const tileClasses = [
        styles.tile,
        isSelected ? styles.selected : '',
        className
    ].filter(Boolean).join(' ');
    return (
        <div className={tileClasses} onClick={onClick} title={name ? `${code} - ${name}` : color}>
            <div className={styles.swatch} style={{ backgroundColor: color }} />
            {(code || name) && (
                <div className={styles.info}>
                    {code && <span className={styles.code}>{code}</span>}
                    {name && <span className={styles.name}>{name}</span>}
                </div>
            )}
        </div>
    );
}
